import { Select } from 'antd';
import React from 'react';

const typeOptions = [
    { id: "operator", key: "equal", text: "equal", value: "equal" },
    { id: "operator", key: "notEqual", text: "notEqual", value: "notEqual" },
    { id: "operator", key: "contains", text: "contains", value: "contains" },
    { id: "operator", key: "doesNotContain", text: "doesNotContain", value: "doesNotContain" }]

const OperatorDropDown = (props) => (
    <Select
        placeholder='Select Operator'
        options={typeOptions}
        defaultValue={props.defaultValue}
        onChange={props.onChange}
    />
)

export default OperatorDropDown